import React from 'react';
import DataTable from "../../../DataTable";
import {inject, observer} from 'mobx-react';
import {observable, action, autorun, toJS} from 'mobx';
import Spinner from "../../../Spinner";

@inject('ticketReasonStore')
@observer
class ReasonList extends React.Component {

  slug = 'monitoring/config/reason';
  reasonColumn = [
    {key: 'id', label: 'Id'},
    {key: 'caption', label: 'Caption'},
    {key: 'description', label: 'Description'},
    {key: 'color', label: 'Color'},
  ];

  handleDelete = (idOrIds) => {
    console.log('handleDelete', idOrIds);
    this.props.ticketReasonStore.removeItems(idOrIds);
  };

  render() {
    const {ticketReasonStore} = this.props;
    let data = ticketReasonStore.items.map(({id, caption, description, color}) => ({
      id,
      caption,
      description,
      color: <svg viewBox="0 0 20 20" x="10" width="20">
        <circle cx="10" cy="10" r="8" stroke="grey" strokeWidth="0.5px" fill={color} />
      </svg>
      // color: <i className='fa fa-circle' style={{color}}/>
    }));
    return (
      <div>
        <DataTable data={data} slug={this.slug} columns={this.reasonColumn} onDelete={this.handleDelete}
                   allowAdd
                   allowEdit
                   allowDelete
                   resource='maintenance'
        />
        {ticketReasonStore.isLoading && <Spinner/>}
        {this.props.children}
      </div>
    );
  }
}

export default ReasonList;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/Reason/ReasonList.js